import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * MobileCloseButtonComponent displays a close button for mobile interfaces.
 *
 * @input marginTopPx - The margin-top in pixels to be applied to the button.
 * @output click - Emits an event when the close button is clicked.
 */
@Component({
  selector: 'rk-mobile-close-button',
  templateUrl: './mobile-close-button.component.html',
  styleUrls: ['./mobile-close-button.component.scss'],
})
export class MobileCloseButtonComponent {
  @Input()
  marginTopPx = -22; // -22 is 50% of the height of the button

  @Output()
  click: EventEmitter<Event> = new EventEmitter();
}
